import axios from "axios";
import config from "./../config";

export default {
  async get_ui(token) {
    console.log("ui.get_ui", token);
    if (token) return await axios.post(`${config.endpoint}/ui`, { token });
    else return false;
  }
};
